export default function famchart({ next, store }) {
  if (store.getters["auth/hasFam"]) next();
  else next({ name: "notFound" });
}
